'use strict'
const React = require('react')
const querystring = require('querystring')
const PropTypes = require('prop-types')
const Link = require('@npm/spiferack/link')

const connect = require('../../components/connect')
const styles = require('./pagination.css')

// for /browse/  pages where we do not no the total, and
// just have prev/next with a fixed page size of 36
class SimplePagination extends React.PureComponent {
  render() {
    const {hasNext, hasPrev, paginationSize, url} = this.props
    const [base, existingSearch] = url.split('?')
    const existingQuery = querystring.parse(existingSearch)
    const {offset = 0} = existingQuery
    const prevQuery = Object.assign(existingQuery, {offset: +offset - paginationSize})
    const prevSearch = querystring.stringify(prevQuery)
    const nextQuery = Object.assign(existingQuery, {offset: +offset + paginationSize})
    const nextSearch = querystring.stringify(nextQuery)
    return (
      <div className={styles.pagination}>
        {hasPrev && (
          <div className={styles.page} key="nav-prev">
            <Link>
              <a href={`${base}?${prevSearch}`}>{'Previous Page'}</a>
            </Link>
          </div>
        )}
        {hasNext && (
          <div className={styles.page} key="nav-next">
            <Link>
              <a href={`${base}?${nextSearch}`}>{'Next Page'}</a>
            </Link>
          </div>
        )}
      </div>
    )
  }
}

SimplePagination.propTypes = {
  hasNext: PropTypes.bool,
  hasPrev: PropTypes.bool,
  offset: PropTypes.number,
}

SimplePagination.defaultProps = {
  offset: 0,
}

module.exports = connect()(SimplePagination)
